import methods from "./methods";
import Computed from "./computed";
export default {
  data() {
    return {};
  },
  computed: Computed,
  mounted() {},
  methods: methods,
  filters: {},
};
